"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;

var CertificateParser_1 = require("../CertificateParser");

var shared_1 = require("../shared");

var Errors_1 = require("../../common/Errors");

var parse = require("date-fns/parse");

var _memoize = require("lodash/memoize");

var Log_1 = require("../../common/Log");

var constants_1 = require("../constants");

var utils_1 = require("../utils");

var Metrics_1 = require("../../common/Metrics");

var subjectRDNReplacementScheme = [{
  from: '1.2.840.113549.1.9.2',
  to: 'UN'
}, {
  from: '1.2.643.100.5',
  to: 'ОГРНИП'
}];
var ErrorCodes;

(function (ErrorCodes) {
  ErrorCodes["ParsingError"] = "ParsingError";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));

var Certificate =
/** @class */
function () {
  function Certificate(c) {
    var _this = this;

    this.subjectRDN = {};
    this.issuerRDN = {};
    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "PluginCertificate");
    this.metrics = Metrics_1.MetricsManager.getMetrics(constants_1.METRICS_CATEGORY);

    this.type = function () {
      return shared_1.CertificateType.Iron;
    };

    this.thumbprint = function () {
      return _this.rawCertificate.hash.data.toLowerCase();
    };

    this.inn = function () {
      return CertificateParser_1["default"].inn(_this.subjectRDN);
    };

    this.kpp = function () {
      return CertificateParser_1["default"].kpp(_this.subjectRDN, _this.subjectType);
    };

    this.issuer = function () {
      return CertificateParser_1["default"].issuer(_this.issuerRDN);
    };

    this.owner = function () {
      return CertificateParser_1["default"].owner(_this.subjectRDN);
    };

    this.organizationName = function () {
      return CertificateParser_1["default"].organizationName(_this.subjectRDN, _this.subjectType);
    };

    this.validTo = function () {
      return parse(_this.rawCertificate.validTo || '');
    };

    this.validFrom = function () {
      return parse(_this.rawCertificate.validFrom || '');
    };

    this.serialNumber = function () {
      return _this.rawCertificate.serialNumber ? _this.rawCertificate.serialNumber.data.toLowerCase() : '';
    };

    this.hasPrivateKey = function () {
      return !!_this.rawCertificate.hasPrivateKey;
    };

    this.isQualified = function () {
      return !!_this.rawCertificate.qualified;
    };

    this.isCloud = function () {
      return CertificateParser_1["default"].isCloud(_this.rawCertificate.extensions);
    };

    this.cryptoProvider = function () {
      return _this.rawCertificate.cryptoProvider;
    };

    this.containerInfo = function () {
      return _this.rawCertificate.containerInfo;
    };

    this.publicKeyLength = function () {
      return _this.rawCertificate.publicKeyLength;
    };
    /**
     * Плагин возвращает алгоритм публичного ключа начиная с версии 3.10.4.
     * Для ранних версий Плагина используется функция getPublicKeyAlgorithm.
     * В этом случае определение алгоритма возможно если в rawCertificate
     * есть поле content.
     */


    this.publicKeyAlgorithm = function () {
      var algorithm = _this.rawCertificate.publicKeyAlgorithm;

      if (algorithm) {
        return algorithm;
      }

      var base64 = _this.toBase64();

      if (base64) {
        var hex = void 0;

        try {
          hex = utils_1.base64ToHex(base64);
        } catch (e) {
          _this.log.error("Convert base64 to hex error: " + e.message);
        }

        if (hex) {
          algorithm = utils_1.getPublicKeyAlgorithm(hex);
        }
      }

      return algorithm;
    };

    this.licenseBuiltin = function () {
      return CertificateParser_1["default"].licenseBuiltin(_this.rawCertificate.extensions);
    };

    this.ogrn = function () {
      return _this.subjectRDN['ОГРН'] || _this.subjectRDN['ОГРНИП'] || '';
    };

    this.toBase64 = function () {
      return _this.rawCertificate.content ? _this.rawCertificate.content.data : '';
    };

    this.extensions = function () {
      return _this.rawCertificate.extensions || {};
    };

    this.raw = function () {
      return _this.rawCertificate;
    };

    this.memoizeCertProps = function () {
      _this.thumbprint = _memoize(_this.thumbprint);
      _this.inn = _memoize(_this.inn);
      _this.kpp = _memoize(_this.kpp);
      _this.issuer = _memoize(_this.issuer);
      _this.owner = _memoize(_this.owner);
      _this.organizationName = _memoize(_this.organizationName);
      _this.validTo = _memoize(_this.validTo);
      _this.validFrom = _memoize(_this.validFrom);
      _this.serialNumber = _memoize(_this.serialNumber);
      _this.hasPrivateKey = _memoize(_this.hasPrivateKey);
      _this.isQualified = _memoize(_this.isQualified);
      _this.isCloud = _memoize(_this.isCloud);
      _this.cryptoProvider = _memoize(_this.cryptoProvider);
      _this.licenseBuiltin = _memoize(_this.licenseBuiltin);
      _this.ogrn = _memoize(_this.ogrn);
      _this.toBase64 = _memoize(_this.toBase64);
      _this.containerInfo = _memoize(_this.containerInfo);
      _this.publicKeyLength = _memoize(_this.publicKeyLength);
      _this.publicKeyAlgorithm = _memoize(_this.publicKeyAlgorithm);
    };

    this.savePritableVersion = function () {
      _this.printableCertificate = {
        type: _this.type(),
        thumbprint: _this.thumbprint(),
        inn: _this.inn(),
        kpp: _this.kpp(),
        issuer: _this.issuer(),
        owner: _this.owner(),
        organizationName: _this.organizationName(),
        validTo: _this.validTo(),
        validFrom: _this.validFrom(),
        serialNumber: _this.serialNumber(),
        hasPrivateKey: _this.hasPrivateKey(),
        isQualified: _this.isQualified(),
        isCloud: _this.isCloud(),
        cryptoProvider: _this.cryptoProvider(),
        licenseBuiltin: _this.licenseBuiltin(),
        ogrn: _this.ogrn(),
        toBase64: _this.toBase64(),
        containerInfo: _this.containerInfo(),
        publicKeyLength: _this.publicKeyLength(),
        publicKeyAlgorithm: undefined,
        extensions: _this.extensions()
      };
    };

    this.combineRDN = function (arRDN) {
      return arRDN.reduce(function (obj, item) {
        return __assign({}, obj, item);
      }, {});
    };

    var thumbprint;

    try {
      this.rawCertificate = c;
      thumbprint = c.hash.data;

      if (c.subject) {
        var rdn = this.combineRDN(c.subject);
        this.subjectRDN = CertificateParser_1["default"].replaceRDNKeys(rdn, subjectRDNReplacementScheme);
      }

      if (c.issuer) {
        this.issuerRDN = this.combineRDN(c.issuer);
      }

      this.subjectType = CertificateParser_1["default"].subjectType(this.subjectRDN);
      this.memoizeCertProps();
      this.savePritableVersion();
    } catch (error) {
      var message = "\u0421ertificate parse error: " + error.message;
      this.log.error(message);
      this.metrics.trackEventNC('PluginCertificate', 'Error', {
        code: ErrorCodes.ParsingError,
        thumbprint: thumbprint || 'empty',
        message: message
      });
      throw new Errors_1.CommonError(message, null, ErrorCodes.ParsingError);
    }
  }

  return Certificate;
}();

exports["default"] = Certificate;